import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

const GetQuotationDetailsById = (quotationId) => {
    return useQuery(
        ["get-quotation-details-by-id", quotationId],
        () =>
            request({
                url: `quotation/admin/orderDetails/${quotationId}`,
                method: "GET",
            }),
        {
            enabled: !!quotationId,
            refetchOnWindowFocus: false
        }
    );
};

export { GetQuotationDetailsById };
